import React from 'react';
import styles from './styles';
import { useQuery } from '@apollo/react-hooks';
import { GET_USER } from 'graphql/Home';
import { Box, Button, Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import PresentToAllIcon from '@material-ui/icons/PresentToAll';

const LocalSharingScreen = ({ onScreenShareEnd, }) => {
  return (
    <div className="screen-container">
      <Box
        marginTop={6}
        display="flex"
        flexDirection="column"
        alignItems="center"
        bgcolor={'#171819'}
        height={'70vh'}
        justifyContent="center"
      >
        <Box>
          <PresentToAllIcon fontSize='large' />
        </Box>
        <Typography className="presenting-text">
          {'You’re presenting'}
        </Typography>
        <Button onClick={onScreenShareEnd} variant="contained" color="primary">
          Stop presenting
        </Button>
      </Box>
    </div>
  )
}

const RemoteSharingScreen = ({ screenTrack, screenRef }) => {
  const { data } = useQuery(GET_USER, {
    variables: { sub: screenTrack.participant.identity },
  });

  const user = data?.user[0] || null;

  return (
    <div className="screen-container">
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        marginTop={-1}
        maxHeight={32}
      >
        {user && (
          <Typography className="screen-share-text">
            {`${user.user_first_name} is presenting`}
          </Typography>
        )}
      </Box>
      <video className="screen" ref={screenRef} autoPlay />
    </div>
  )
}

const ScreenTrack = ({ screenRef, screenTrack, isLocal, onScreenShareEnd }) => {
  if (isLocal) {
    return <LocalSharingScreen onScreenShareEnd={onScreenShareEnd} />
  } else if (screenTrack) {
    return <RemoteSharingScreen screenRef={screenRef} screenTrack={screenTrack} />
  }
  return null;
};

export default withStyles(styles)(ScreenTrack);
